import { render, staticRenderFns } from "./DimishedValueCalculate.vue?vue&type=template&id=2857887d&scoped=true&"
import script from "./DimishedValueCalculate.vue?vue&type=script&lang=js&"
export * from "./DimishedValueCalculate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2857887d",
  null
  
)

export default component.exports